"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.boxInput = void 0;

var _themeConfig = _interopRequireDefault(require("@lyearn-team/theme-config"));

var _reactEmotion = require("react-emotion");

var boxInput =
/*#__PURE__*/
(0, _reactEmotion.css)("box-sizing:border-box;width:100%;background-color:", _themeConfig.default.color.dark.mars, ";border:none;padding:14px 20px 14px;font-size:16px;line-height:1.5;color:", _themeConfig.default.color.dark.silver, ";outline:none;resize:none;::placeholder{color:", _themeConfig.default.color.dark.iron, ";}");
exports.boxInput = boxInput;